module.exports = __webpack_public_path__ + "assets/ico-input-invalid.521e1a16.svg";